import React from 'react';
import { connect } from 'react-redux';
import {
    Card, CardBlock, CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';
import {
    AreaChart, Area, BarChart, Bar,
    PieChart, Pie,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell, Sector,
    ResponsiveContainer
} from 'recharts';

import {Link} from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";

import IconPrint from 'react-icons/lib/fa/print';
import IconOpen from 'react-icons/lib/fa/folder-open-o';
import FAplus from 'react-icons/lib/fa/plus';
import FAprint from 'react-icons/lib/fa/print';

import * as actions from '../../actions/ticket';

import {API_URL} from '../../actions/_request';
import {api,API_UR} from '../../actions/_request';
const {PropTypes} = React;
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };

        


const CustomTooltip  = React.createClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label,fill } = this.props;
      // style={{width: '100%', height: '280px'}}
      // console.log('propiedades grafica--->',this.props);
      return (
        <div className="custom-tooltip">
        {
          payload.map((item, i) => 
          <p className="label text-capitalize" style={{ 'color': ''+item.fill }} >{`${item.name} : ${new Intl.NumberFormat().format(item.value)}`}</p>
          )
        }
                         
        </div>
      );
    }
    return null;
  }
});

class TicketTable extends React.Component {

    constructor(props) {

        super(props);

   this.state = {     
      data:[]
          };

    

    }

    formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '$' + result;
}

   

   

    render() {
      console.log("Lista tickets---->",this.props.tecnicos);
      let grafica=[];
      if(this.props.grafica == null ||typeof this.props.grafica === 'undefined'){

      }else{
        grafica=this.props.grafica;
      }
     

        return(
            <div className="view">

            
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase"> Listado de Tecnicos</h1>
                        
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                    <CardBlock>
                        <CardTitle className="text-uppercase h6">Cumplimiento de Citas  </CardTitle>
                        <div className="small mb-4 card-subtitle"></div>
                        <div style={{width: '100%', height: '280px'}}>
                            <ResponsiveContainer>
                                <BarChart width={730} height={250} data={grafica}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="label" />
                                  <YAxis />
                                  {
                                    Object.keys(grafica).length > 0&&
                                    <Tooltip content={<CustomTooltip/>}/>
                                  }
                                  <Legend />
                                  <Bar dataKey="Total" fill='#406CBF'  minPointSize={1} />
                                 
                                  
                                   
                                    <Bar dataKey="Cumplidas" fill='green'  minPointSize={1} />
                                  
                                  
                                    <Bar dataKey="Retardos" fill='orange'  minPointSize={1} />
                                  
                                  
                                    
                                    <Bar dataKey="Retardos Criticos" fill='red'  minPointSize={1} />
                                  
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </CardBlock>
                        <CardBlock>
                        <div className="row justify-content-end">
                       
                          
                          
                        </div>
                           
                            <ReactTable
                              data      = {this.props.tecnicos}
                              className = "-striped -highlight"
                              columns   = {[
                                {Header: 'Tecnico', accessor: 'tecnico'},
                                {Header: 'Cumplidas', accessor: 'Cumplidas',maxWidth:150 , style: { 'textAlign': 'center'}}, 
                                {Header: 'Retardos', accessor: 'Retardos',maxWidth:150 , style: { 'textAlign': 'center'}}, 
                                {Header: 'Retardos Criticos', accessor: 'Retardos Criticos',maxWidth:150 , style: { 'textAlign': 'center'}}, 
                                {Header: 'Total', accessor: 'Total',maxWidth:150 , style: { 'textAlign': 'center'}},
                              
                              ]}
                              filterable 
                              defaultPageSize={10} 
                              defaultFilterMethod={filterCaseInsensitive}
                            />
                        </CardBlock>
                    </Card>
                </div>

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        ticket: state.ticket,
    }
};

export default connect(mapStateToProps, actions)(TicketTable)


// WEBPACK FOOTER //
// ./src/views/reportes/cumplimientocitas.js